<template>

</template>

<script>
export default {
  name: 'SignIn',
  data: function () {
    return {
      mounted: false,
    }
  },
  computed: {
    ready: function() {
      return this.mounted && this.$auth.auth0Client;
    }
  },
  mounted() {
    this.mounted = true;
  },
  watch: {
    ready: function(newValue) {
      if (newValue) {
        this.signIn();
      }
    }
  },
  methods: {
    signIn() {
      this.$auth.loginWithRedirect({
        appState: {
          targetUrl: `after-auth?from=sign-in`,
        },
        authorizationParams: {
          audience: "https://api.adwayusa.com/auth0"
        }
        // authorizationParams: {
        //   redirect_uri: `${window.location.origin}/after-auth`
        // }
      });
    },
  },
}
</script>
